import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'



declare var window:any

export type definirIdCanalDeVenda = {
    
}

export async function definirIdCanalDeVenda( idCanalDeVenda: number) { // 422642
    
    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirIdCanalDeVenda(
        store.getState().orcamento.IdentificadorOrcamento,
        idCanalDeVenda
    )

    const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model
        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)
        
        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
    }


    atualizarEstado()
}